import React from 'react'
import Card from '../components/card'
import ImageHover from '../components/image-hover'
import styles from '../ResumenADN.module.css';
import educacion from '../../../img/educacion.jpg'
import inversiones from '../../../img/inversion.jpg'
import planificacion from '../../../img/planificacion.jpg'
import proyectos from '../../../img/proyectos.jpg'
import Subtitle from '../../../components/Subtitle/Subtitle'

const CumplirPropositos = ({ name, data }) => {
  return (
    <Card>
      <Subtitle sname={data?.tieneFamilia ? "Te ayudamos a cumplir tus propósitos con" : "Te ayudamos a cumplir tus propósitos"} />
      <div className={styles.container__wrapper}>
        <div className={styles.name}>
          {data?.tieneFamilia ? data.nombres.toLowerCase() : name.toLowerCase()}
        </div>
        {data?.proyectosVida ? (
          <div className={styles.areaGridImages}>
            <div className={styles.areaGridImages__item}>
            <ImageHover
                image={proyectos}
                text={data.proyectosVida[0].descripcion}
            />
            </div>
            <div className={styles.areaGridImages__item}>
            <ImageHover
                image={educacion}
                text={data.proyectosVida[1].descripcion}
            />
            </div>
            <div className={styles.areaGridImages__item}>
            <ImageHover
                image={planificacion}
                text={data.proyectosVida[2].descripcion}
            />
            </div>
            <div className={styles.areaGridImages__item}>
            <ImageHover
                image={inversiones}
                text={data.proyectosVida[3].descripcion}
            />
            </div>
          </div>
        ) : (
          <div className={styles.loadingPropositos}>Cargando propósitos...</div>
        )}
      </div>
    </Card>
  )
}

export default CumplirPropositos
